import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import ItemWineeBj from '../../components/item/item_winee_bj'
import PageSubHeader from '../../components/common/page_sub_header'
import {rootStore} from '../../mobx/store'

const AnalystList = observer((props) => {
  const context = useContext(Page_settings)
  let [type, setType] = useState(0)
  let [memberList, setMemberList] = useState([])
  let [memberListWinee, setMemberListWinee] = useState([])

  useEffect(() => {
    let type = parseInt(props.match.params.type)
    if (isNaN(type)) type = -1
    setType(type)
    getAnalystList(type)
  }, [props.match.params.type])

  const getAnalystList = (type) => {
    context.post('data/an_list', {},
      response => {
        const wineeList = response.winee_list
        setMemberListWinee(wineeList)
        setMemberList(wineeList)
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onLike = (index) => {
    const mb = memberList[index]
    const status = 1 - mb.mb_is_like
    context.onLike(mb, status, false, () => {
      setMemberList(prev => prev.map((it, idx) => {
          it.mb_is_like = idx === index ? status : it.mb_is_like
          return it
        })
      )
    })
  }

  const setAnalyst = (idx) => {
    if (type === idx) return
    setType(idx)
    setMemberList(memberListWinee)
  }

  const onDetail = (info) => {
    props.history.push('/analyst/detail', { info: info, wineeList: memberListWinee })
  }

  const selectBj = (mb_id) => {
    const mb = memberList.filter((item) => {return item.mb_id == mb_id})
    if (mb.length > 0) onDetail(mb[0])
  }

  const onWinee = (info) => {
    const idx = info.mb_lv == 3 ? 1 : 0
    let mb
    mb = memberListWinee.filter((item) => {return item.mb_id == info.mb_id})
    if (mb.length > 0) onDetail(mb[0])
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft type={2} wineeList={memberListWinee} onWinee={(info) => {onWinee(info)}} history={props.history} />
        <div className='im-container'>
          <PageSubHeader className={'sm-none'} pageName={strings.analyst_winee} pageMenu1={strings.main} pageMenu2={strings.analyst_member} pageMenu={strings.analyst_winee}/>
          <div className='sm-inherit'>
            <div className='d-flex align-items-center'>
              <div className={'sm-fs-20 f-b cursor-point'}>{strings.analyst_winee}</div>
            </div>
          </div>
          <select className='form-control sm-inherit custom_select mt-15' onChange={(e) => {selectBj(parseInt(e.target.value))}}>
            <option value={0}>{strings.all}</option>
            {memberList.map((it, idx) => {return (<option value={it.mb_id} key={idx}>{it.mb_nick}</option>)})}
          </select>
          <div className='v-analyst-list'>
            {memberList.map((it, idx) => {return (<ItemWineeBj key={idx} info={it} type={1} onDetail={() => {onDetail(it)}} onLike={() => {onLike(idx)}}/>)})}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(AnalystList)
